/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const greenApiWebhookSenderDataSchema = z.object({
	chatId: z.string(),
	senderPhoneNumber: z.string().nullish(),
});
